/**
 * Add a new company
 *
 * @param company
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as cargoPortActions from "../graphql/actions/cargoPort";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as creationActions from "./creation";
import * as cargoActions from "./cargo";

export function add(cargoPort, fogId) {
    return dispatch => {
        //dispatch(loading());
        dispatch(saving(cargoPort));
        cargoPortActions.add(
            function (response) {
                dispatch(saved(response.data.createCargoPort));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedCargoPort(response.data.createCargoPort));
                if (fogId !== undefined) {
                    dispatch(cargoActions.fetchCargoes(fogId, true));
                }
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            cargoPort
        );
    };
}


export function edit(cargoPort, fogId = undefined) {
    let id = cargoPort.id;
    delete cargoPort.id;
    delete cargoPort.__typename;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(cargoPort));
        cargoPortActions.edit(
            function (response) {
                dispatch(saved(response.data.editCargoPort));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                if (fogId !== undefined) {
                    dispatch(cargoActions.fetchCargoes(fogId, true));
                }
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            cargoPort
        );
    };
}

export function loading() {
    return {
        type: types.LOADING_CARGO_PORT
    };
}

export function saving(cargoPort) {
    return {
        type: types.SAVING_CARGO_PORT,
        payload: cargoPort
    };
}

export function saved(cargoPort) {
    return {
        type: types.SAVED_CARGO_PORT,
        payload: cargoPort
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_CARGO_PORT,
    };
}

export function receiveCargoPorts(data) {
    return {
        type: types.RECEIVED_CARGO_PORTS,
        payload: data
    };
}


export function receiveCargoPort(data) {
    return {
        type: types.RECEIVED_CARGO_PORT,
        payload: data
    };
}


// WEBPACK FOOTER //
// ./src/actions/cargoPort.js